import DealerIcon from '../icons/dealer'
import CherryIcon from '../icons/cherry'
import MartiniIcon from '../icons/martini'
import FireIcon from '../icons/fire'

// Category details for thumbnail sliders
export const CATEGORY_DETAILS = {
  popular: {
    textKey: 'carouselHeading.featuredGames',
    defaultText: 'Featured Games',
    linkHref: '',
    icon: <FireIcon width="16" height="16" className="text-carouselHeading" />,
  },
  live: {
    textKey: 'carouselHeading.topLiveGames',
    defaultText: 'Top Live Games',
    linkHref: '/casino?tab=live',
    icon: <DealerIcon width="16" height="16" className="text-carouselHeading" />,
  },
  slots: {
    textKey: 'carouselHeading.topSlotGames',
    defaultText: 'Top Slot Games',
    linkHref: '/casino?tab=slots',
    icon: <CherryIcon width="16" height="16" className="text-carouselHeading" />,
  },
  gameshows: {
    textKey: 'carouselHeading.gameShows',
    defaultText: 'Game Shows',
    linkHref: '',
    icon: <MartiniIcon width="16" height="16" className="text-carouselHeading" />,
  },
  new: {
    textKey: 'carouselHeading.newReleases',
    defaultText: 'New Releases',
    linkHref: '',
    icon: <FireIcon width="16" height="16" className="text-carouselHeading" />,
  },
  userrecommendations: {
    textKey: 'carouselHeading.recommendedGames',
    defaultText: 'Recommended For You',
    linkHref: '',
    icon: <FireIcon width="16" height="16" className="text-carouselHeading" />,
  },
  similar: {
    textKey: 'carouselHeading.similarGames',
    defaultText: 'Similar Games',
    linkHref: '',
    icon: <FireIcon width="16" height="16" className="text-carouselHeading" />,
  },
}

export type CategoryKey = keyof typeof CATEGORY_DETAILS
